import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";
import { PanelErrorType } from "../../../utils/constants/panelMessage/PanelErrorMessage";
import { PanelSuccessMsgType } from "../../../utils/constants/panelMessage/PanelSuccessMessage";

export type PanelMessageType = PanelErrorType | PanelSuccessMsgType | null;

interface PanelMessageState {
  messageType: PanelMessageType;
}

const initialState: PanelMessageState = {
  messageType: null,
};

const panelMessageSlice = createSlice({
  name: "panelMessage",
  initialState: initialState,
  reducers: {
    setPanelMessage: (state, action: PayloadAction<PanelMessageType>) => {
      state.messageType = action.payload;
    },
    clearPanelMessage: (state) => {
      state.messageType = null;
    },
  },
  extraReducers: undefined,
});

export const getMessageType = (state: RootState) => state.panelMessage.messageType;
export const { setPanelMessage, clearPanelMessage } = panelMessageSlice.actions;
export default panelMessageSlice.reducer;
